import type { TestFunction } from 'yup';

import { FieldErrors } from 'shared/lib/fields';
import type { TDadataFullNameSuggest } from 'shared/types/TDaData';

export const validateSurname: TestFunction<Dictionaries.TSelectValue<string, TDadataFullNameSuggest['data']>> = (
  value,
  context,
) => {
  const { surname } = value.data || {};
  if (!surname) {
    return context.createError({
      path: context.path,
      message: FieldErrors.surnameError,
    });
  }

  return true;
};
